import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import enJson from "../../locales/en.default.json";
import deJson from "../../locales/de.json";
import frJson from "../../locales/fr.json";
import itJson from "../../locales/it.json";
import esJson from "../../locales/es.json";

const resources = {
  en: {
    translation: {
      ...enJson,
    },
  },
  de: {
    translation: {
      ...deJson,
    },
  },
  fr: {
    translation: {
      ...frJson,
    },
  },
  it: {
    translation: {
      ...itJson,
    },
  },
  es: {
    translation: {
      ...esJson,
    },
  },
};

const lng = window.Shopify?.locale;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng,
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
